import { useQuery } from '@tanstack/react-query'
import {
  getActiveBoxCollections,
  type BoxCollectionDto,
  type BoxCollectionSettingsDto,
} from '../api/boxCollectionsApi'

export const useActiveBoxCollections = () => {
  return useQuery({
    queryKey: ['ActiveBoxCollections'],
    queryFn: getActiveBoxCollections,
    staleTime: Infinity, // Always consider data fresh
  })
}

export type { BoxCollectionDto, BoxCollectionSettingsDto }
